module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAPCAYAAAD6Ud/mAAAA8ElEQVQ4ja3PzSqEYRQH8OPrLpT1+MjHxk6SME2ScA+SJMlFKFdh6VKsXYCVb7vBED+rN2+Pad73mebUf3XOv19nCJE54xExEhG3OaXhTKQREdcRcRMRS1lN1E0Dd/6mjeW6/brIJO79nzZWBgVN4SEBvnOxKmQajwlyhj18Jdhqv9BMF+S0tN/FZ4Kt5UKzXZCTLncp9ob1utAcnhLkuMfnO+iUbt+xUQXN47lU+qlAimxXYVXIUQ2kyFaCfaCZQgt4SZDDDKTIZoJ10CqgCbwmyEEfSC9ssVheDAgp0iphVxgrL8+xPwCkSBOXGEX8ApopWzdtYDRgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/totop.png
// module id = btNM
// module chunks = 0